import React from 'react'
import { Grid, List } from 'semantic-ui-react';

import profile from "./../../../../../images/common/jenny.jpg";
import noWorkspace from "./../../../../../images/grafix-banner/noWorkspace.svg";
import Labels from './../../../../common/Labels';
import momentDateAndTime from './../../../../../helpers/momentDateAndTime'
import ImageAvater from '../../../../drive/Components/ImageAvater';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';

let img = {
    profile: profile,
    noWorkspace: noWorkspace
}
class InitiativeDetail extends React.Component {

    render() {

        let selectedActivityData = this.props.selectedActivityData.initiativeId;

        return (
            <Grid columns={4} >
                <Grid.Row>
                    <Grid.Column width={10} className="setLabel">
                        <Labels
                            name="Name"
                            text={selectedActivityData.name ? selectedActivityData.name : ""}
                        />



                        {selectedActivityData && selectedActivityData.teamId ?
                            <Labels
                                name="Team Name"
                                text={selectedActivityData.teamId.name}
                            />
                            :
                            <Labels
                                name="Workspace Name"
                                text={selectedActivityData.organizationId.name}
                            />
                        }
                        <Labels
                            name="Schedule"
                            text={<div>
                                {momentDateAndTime(selectedActivityData.startDate)} to &nbsp;
                                {momentDateAndTime(selectedActivityData.endDate)}
                                ({selectedActivityData.totaldays ? selectedActivityData.totaldays : ""}
                                {selectedActivityData.totaldays && selectedActivityData.totaldays === 1 ? "Day" : "Days"} )
                         </div>}
                        />

                    </Grid.Column>
                    <Grid.Column width={6}>
                        <img src={selectedActivityData.picture ? selectedActivityData.picture : img.noWorkspace} className="fitImage" alt='' />
                    </Grid.Column>

                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={16} className="setLabel">
                        <Labels
                            name="Owner"
                            text={
                                <List horizontal >
                                    <List.Item>
                                        <ImageAvater user={selectedActivityData.createdBy} />
                                        <div className="float-left mar_tb_2" >
                                            <EllipsisTooltip
                                                name={selectedActivityData.createdBy && selectedActivityData.createdBy.firstName + ' ' + selectedActivityData.createdBy.lastName}
                                                line={2}
                                                style={{ 'lineHeight': '20px' }}
                                            />
                                        </div>



                                    </List.Item>
                                </List>
                            }
                        />

                        <Labels
                            name="Description"
                            text={selectedActivityData.description ? selectedActivityData.description : ""}
                            htmlView={true}
                        />

                    </Grid.Column>
                </Grid.Row>

            </Grid>
        )
    }
}

export default InitiativeDetail
